import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { Can } from "../../../../../../service/service";

interface StatusProps {
    state: Can;
}

export const Maps: { [key: string]: string } = {
    [Can.no]: "未发布",
    [Can.yes]: "已发布"
};

export default function TagStatus({ state }: StatusProps) {
    const classMap: { [key: string]: string } = {
        "0": style.state,
        "1": style.doing
    };

    return (
        <span className={classNames(style.root, classMap[state])}>
            {Maps[state]}
        </span>
    );
}
